var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"register-tab",class:[
    _vm.loggedUser.role === 'SuperAdmin' &&
      _vm.$route.path.includes('/registered') &&
      'register-tab-super',
  ]},[_c('v-tabs',{staticClass:"mb-2",model:{value:(_vm.tabModel),callback:function ($$v) {_vm.tabModel=$$v},expression:"tabModel"}},[_c('v-tab',{on:{"click":function($event){return _vm.tabClicked('users')}}},[_vm._v("Users")]),_c('v-tab',{on:{"click":function($event){return _vm.tabClicked('routes')}}},[_vm._v("Routes")])],1),_c('router-view',{on:{"tabClicked":_vm.tabClicked}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }